export function getCookie(name: string): string | null {
    const match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
}

type SetCookieOptions = {
    maxAgeSeconds?: number;
    path?: string;
    domain?: string;
    sameSite?: 'Lax' | 'Strict' | 'None';
    secure?: boolean;
};

export function setCookie(name: string, value: string, opts: SetCookieOptions = {}) {
    const parts: string[] = [`${name}=${encodeURIComponent(value)}`];

    if (opts.maxAgeSeconds != null) parts.push(`Max-Age=${opts.maxAgeSeconds}`);
    parts.push(`Path=${opts.path ?? '/'}`);

    if (opts.domain) parts.push(`Domain=${opts.domain}`);
    parts.push(`SameSite=${opts.sameSite ?? 'Lax'}`);

    if (opts.secure) parts.push('Secure');

    document.cookie = parts.join('; ');
}
